"use client";
import { ChevronUp } from "@/components/newIcons/ChevronUp";
import clsx from "clsx";
import { type ReactNode, useEffect, useState } from "react";
import type { Version } from "../../getVersion";

type Props = {
  step: Version["steps"][number];
  dayTitle: string;
  stepTitle: string;
  stepDescription: ReactNode;
  isInitOpen?: boolean;
};
export const Step = ({ step, dayTitle, stepTitle, stepDescription, isInitOpen = false }: Props) => {
  const [isOpen, setIsOpen] = useState(isInitOpen);

  useEffect(() => {
    setIsOpen(isInitOpen);
  }, [isInitOpen]);

  return (
    <div className="border border-[#E5E5E5] rounded-[5px] mt-5 p-5 scroll-m-36" id={step.id.toString()}>
      <div
        className="flex flex-col lg:flex-row items-start lg:items-center cursor-pointer select-none relative"
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className="text-white bg-[#B95733] text-sm lg:text-base lg:leading-5 font-bold rounded-[5px] py-0.5 px-3 whitespace-nowrap">
          {dayTitle}
        </p>
        <p
          className={clsx(
            "text-primary text-sm lg:text-base lg:leading-5 font-bold lg:px-3 max-lg:mt-[10px] lg:mr-16",
            {
              "line-clamp-1": !isOpen,
            },
          )}
        >
          {stepTitle}
        </p>
        <div className="absolute flex items-center top-0 right-0 h-6">
          <p className="font-semibold text-primary text-sm pr-0.5">{isOpen ? "FERMER" : "OUVRIR"}</p>
          <ChevronUp
            className={clsx("w-4 h-4 transition-all text-primary", {
              "rotate-180": !isOpen,
            })}
          />
        </div>
      </div>
      {step.description && <div className={clsx({ hidden: !isOpen })}>{stepDescription}</div>}
    </div>
  );
};
